import { ReactElement } from "react";
import { Flex, Text, TextProps } from "shared/components/Spor";
import styled from "styled-components";

const Row = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 10.5rem auto;
  padding: 0 0.5rem;
  align-items: center;
`;

const Column = styled(Flex)`
  flex-direction: column;
  &&& {
    align-items: start;
  }
`;

type ColumnOrRow =
  | { column: boolean; row?: boolean }
  | { column?: boolean; row: boolean };

type TitleSubtitleChildrenProps = {
  title?: string;
  subtitle?: string;
  smallSubtitle?: boolean;
  children?: ReactElement | ReactElement[];
} & TextProps;

const Content = ({
  title,
  subtitle,
  smallSubtitle,
  children,
  style,
  ...rest
}: TitleSubtitleChildrenProps) => (
  <>
    {title && (
      <Text
        fontWeight="bold"
        {...rest}
        style={{ fontSize: "16px", whiteSpace: "nowrap", ...style }}
      >
        {title}
      </Text>
    )}
    {subtitle && (
      <Text
        fontWeight={400}
        {...rest}
        style={{
          fontSize: smallSubtitle ? "16px" : "18px",
          whiteSpace: "nowrap",
          ...style,
        }}
      >
        {subtitle}
      </Text>
    )}
    {children}
  </>
);

export const TitleSubtitleChildren = ({
  column: _,
  row,
  ...rest
}: ColumnOrRow & TitleSubtitleChildrenProps) =>
  row ? (
    <Row>
      <Content {...rest} />
    </Row>
  ) : (
    <Column>
      <Content {...rest} smallSubtitle />
    </Column>
  );
